export default __webpack_public_path__ + "static/media/gcv-icon.bb44c9dc.svg";